import React from 'react'
import { EmailShareButton } from 'react-share'
import styled from 'styled-components'
import { Mail } from 'react-feather'
import { ShareButtonProps } from './types'

const StyledIcon = styled(Mail)`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.gray6};
`

const MailShare: React.FC<ShareButtonProps> = ({ url, title }) => {
  return (
    <EmailShareButton url={url} title={title} subject={title}>
      <StyledIcon />
    </EmailShareButton>
  )
}

export default MailShare
